import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

export const saveUserProfile = async (user) => {
  if (!user) return;

  const ref = doc(db, "users", user.uid);

  await setDoc(
    ref,
    {
      email: user.email,
      name: user.displayName,
      photo: user.photoURL,
      isGuest: false,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};
